import { Anchor, Flex, Text, TextInput } from '@mantine/core'
import { useDebouncedValue } from '@mantine/hooks'
import { useEffect, useState } from 'react'

import { Trans, useTranslation } from '@flecto/translations'
import { CollapsibleCard, useModal } from '@flecto/ui'

import { useCustomDomainCheck } from '../../hooks/useCustomDomainCheck'
import { useCustomDomainDescription } from '../../hooks/useCustomDomainDescription'
import { FormImages } from '../FormStoreSettings/FormImages'
import { FormSection } from '../FormStoreSettings/FormSection'
import { useFormContext } from '../FormStoreSettings/FormStoreSettings'
import { ModalStoreCustomDomain } from '../ModalStoreCustomDomain/ModalStoreCustomDomain'
import styles from './styles.module.css'

export function CardStoreCustomDomain() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_store' })

  const form = useFormContext()

  const checkDomain = useCustomDomainCheck({ form })

  const { openModal } = useModal(<ModalStoreCustomDomain />)

  const { description } = useCustomDomainDescription()
  const [valueDomain, setValueDomain] = useState('')
  const [domain] = useDebouncedValue(valueDomain, 500)

  useEffect(() => {
    form.setFieldValue('apex_domain', domain)
    checkDomain(domain)
  }, [domain])

  useEffect(() => {
    if (form.values.apex_domain !== domain) {
      setValueDomain(form.values.apex_domain ?? '')
    }
  }, [form.values])

  return (
    <FormSection>
      <CollapsibleCard opened>
        <CollapsibleCard.Title>
          {t('section_custom_domain.title')}
        </CollapsibleCard.Title>
        <CollapsibleCard.Description>
          <Trans
            ns='saas'
            i18nKey='profile_store.section_custom_domain.description'
            components={[
              <Anchor
                key={1}
                href='javascript:void(0)'
                onClick={(e) => {
                  e.stopPropagation()
                  openModal()
                }}
              />,
            ]}
          />
        </CollapsibleCard.Description>
        <CollapsibleCard.Content>
          <TextInput
            mt='sm'
            key={form.key('apex_domain')}
            className={styles.inputDomain}
            placeholder={t('section_custom_domain.url_placeholder')}
            leftSection='https://'
            value={valueDomain ?? ''}
            onChange={(e) => setValueDomain(e.currentTarget.value)}
            error={form.errors.apex_domain}
          />
          {description && (
            <Flex align='center' gap='xs' mt='sm'>
              {description.icon}
              <Text size='sm' c={description.color}>
                {description.text}
              </Text>
            </Flex>
          )}
        </CollapsibleCard.Content>
      </CollapsibleCard>
      <FormImages images={[require('./image.jpeg')]} />
    </FormSection>
  )
}
